import { CommonModule } from '@angular/common';
import { Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

const DEFAULT_INPUT_CLASS = 'form-control rounded-pill cbb-input border border-primary';

let instanceCounter = 0;

@Component({
  selector: 'cbb-text-field-mask',
  standalone: true,
  imports: [FormsModule, CommonModule, NgxMaskDirective],
  templateUrl: './text-field-mask.component.html',
  styleUrl: './text-field-mask.component.scss',
  providers: [provideNgxMask()],
})
export class TextFieldMaskComponent {
  protected readonly fieldId = `cbb-text-mask-${++instanceCounter}`;

  label = input<string>('');
  value = model<string>('');
  placeholder = input<string>('');
  readonly = input<boolean>(false);
  mensajeError = input<string>('');
  shownMaskExpression = input<string>('');
  /** Ajusta la apariencia sin cambiar el comportamiento de máscara. */
  appearance = input<'checkout' | 'admin'>('checkout');
  prefix = input<string>('');
  mask = input<string>('0 00 000 000');
  inputClass = input<string>(DEFAULT_INPUT_CLASS);
  isInvalid = input<boolean>(false);
  valueOnBlur = output<string>();
  valueOnInput = output<string>();

  onBlur(event: Event): void {
    const nuevoValor = (event.target as HTMLInputElement).value;
    this.value.set(nuevoValor);
    this.valueOnBlur.emit(nuevoValor);
  }

  onInput(event: Event): void {
    const nuevoValor = (event.target as HTMLInputElement).value;
    this.value.set(nuevoValor);
    this.valueOnInput.emit(nuevoValor);
  }
}
